import React, { Component } from 'react';
import { FormGroup, Input, Button, ListGroupItem, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import Slider from "react-slick";
import { data } from '../../constants/Constants';
import CounterInput from '../../components/reusable/CounterInput';
import c from '../../constants/Colors';
import { getDataFiltros } from '../../store/sagas/pedidoApi';
import localStorageCustom from '../../utilitarios/localStorage';
import { notificacion,getStatePage} from '../../utilitarios/util';
import Spinner from "../reusable/Loader";

const CardOferta = ({  }) => {
  return (
    <div className="card_product_horizontal">
      <div className="cphLeftImage">
        <img src={'../../assets/img/product.png'} />
      </div>
      <div className="cphTextCenter">
        <h6 className="paragraph-2 bold morado mb-1">Arandela de Cobre</h6>
        <span className="paragraph-3 mb-3" style={{ color: c.grisOscuro }}>SKU: DJ101217</span>
        <span className="paragraph-3 previousPrice" style={{ color: c.grisOscuro }}>PVD S/ 25.00 c/u</span>
        <strong className="paragraph-3 bold naranja">PVD S/ 17.60 c/u</strong>
        <span className="paragraph-3">PVD S/ 27.00 c/u</span>
        <div className="text-left mt-2">
          <button className='btn-icon'>
            <SvgAssets icon="icon-trash" fill={c.celeste} />
          </button>
        </div>
      </div>
      <div className="cphCounterInput" style={{ backgroundColor: c.morado, justifyContent: 'space-between' }}>
        {/* <CounterInput
          vertical
          background={c.morado}
          color={"#fff"}
          borderColor={"#fff"}
        /> */}
        <div
          className="btn-link">
          <SvgAssets icon="icon-add-cart" />
        </div>
      </div>
    </div>
  )
}

const ProductoDestacado = ({ }) => {
  return (
    <div className="card_product_vertical">
      <img className="product-img" src={'../../assets/img/product.png'} />
      <h6 className="paragraph-2 bold azul">Arandela de Cobre</h6>
      <span className="paragraph-3 sku">SKU: 36JF0050</span>
      <span className="paragraph-3 previousPrice">PVD S/ 35.00 c/u</span>
      <span className="paragraph-3 bold" style={{ color: c.naranja }}>PVD S/ 20.70 c/u</span>
      <span className="paragraph-3">PVD S/ 37.00 c/u</span>
      <div className="counter">
        {/* <CounterInput
          background={"#fff"}
          color={"#316ACD"}
          borderColor={"#E2E2E2"}
        /> */}
      </div>
      <div className="options">
        <button className="btn-icon" type="button" >
          <SvgAssets icon="icon-star" fill={c.celeste} />
        </button>
        <button className="btn-icon" type="button" >
          <SvgAssets icon="icon-add-cart" className="add-cart" />
        </button>
      </div>
    </div>
  )
}

const ProductoVendido = ({ }) => {
  return (
    <div className="card_product_horizontal gradient_blue" style={{ filter: 'none' }}>
      <div className="cphLeftImage">
        <img src={require('../../assets/img/product.png')} />
      </div>
      <div className="cphTextCenter">
        <h6 className="paragraph-2 bold mb-1" style={{ color: '#fff' }}>Arandela de Cobre</h6>
        <span className="paragraph-3 mb-3" style={{ color: '#fff' }}>SKU: 36JF0050</span>
        <span className="paragraph-3 previousPrice" style={{ color: '#fff' }}>PVD S/ 25.00 c/u</span>
        <strong className="paragraph-3 bold naranja">PVD S/ 17.60 c/u</strong>
        <span className="paragraph-3" style={{ color: '#fff' }}>PVD S/ 27.00 c/u</span>
        <div className="text-left mt-2">
          <button className='btn-icon'>
            <SvgAssets icon="icon-star" fill={c.celeste} />
          </button>
        </div>
      </div>
      <div className="cphCounterInput" style={{ backgroundColor: c.azulClaro, justifyContent: 'space-between' }}>
        {/* <CounterInput
          vertical
          background={c.azulClaro}
          color={"#fff"}
          borderColor={"#fff"}
        /> */}
        <div className="btn-link" style={{ marginTop: 20 }}>
          <SvgAssets icon="icon-add-cart" />
        </div>
      </div>
    </div>
  )
}

export class GenerarPedidoDesktop extends Component {
  static displayName = GenerarPedidoDesktop.name;

  constructor(props) {
    super(props);
    this.state = {
            
    }
  }

  render() {
    var slider_destacados = {
      dots: true,
      infinite: true,
      arrows: false,
      speed: 500,
      slidesToShow: 4,
      // slidesToScroll: 1,
      // variableWidth: true
    };
    var slider_vendidos = {
      dots: true,
      infinite: true,
      arrows: false,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 1,
      variableWidth: true
    };
    return(
      <div id="mhw">
        <div className="title_banner">
          <Container>
            <h1>Generar pedido</h1>
          </Container>
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link to='/'>Dashboard</Link></li>
              <li><Link to='/'>Pedidos</Link></li>
              <li><Link to='/'>Generar Pedido</Link></li>
            </ul>
          </Container>
        </div>
        <div className="container_whit_menu">
          <div className="container_left">
            <div className="card_busqueda_pedido">
              <div className="textContent">
                <h6 className="paragraph-2 morado bold"><SvgAssets icon="icon-codigo" fill={c.morado} />Buscador por Código</h6>
                <p>Esta opción te permitirá realizar búsquedas de repuestos por código o descripción.</p>
              </div>
              <form className="busqueda-pedido">
                <FormGroup className="mb-0">
                  <Input type="text" name="descripcion" placeholder="SKU o Descripción" className="morado"/>
                  <button type="button" className='btn-icon rounded' style={{backgroundColor:c.morado}}>
                    <SvgAssets icon="icon-lupa" fill="#fff" />
                  </button>
                </FormGroup>
              </form>
            </div>
            <div className="card_busqueda_pedido">
              <div className="textContent">
                <h6 className="paragraph-2 verde bold"><SvgAssets icon="icon-moto" fill={c.verdeClaro} />Buscador por Vehículo</h6>
                <p>Esta opción te permitirá realizar búsquedas de repuestos por tipo de modelo de vehículo</p>
              </div>
              <form className="busqueda-pedido">
                <FormGroup>
                  <Input
                    type="select"
                    name="select"
                    className="verde"
                    style={{ flex: 0.5 }}
                  >
                    <option>Año</option>
                  </Input>
                  <Input
                    type="select"
                    name="select"
                    className="verde ml-2">
                    <option>Modelo</option>
                  </Input>
                </FormGroup>
                <FormGroup className="mb-0">
                  <Input
                    type="select"
                    name="select"
                    className="verde">
                    <option>Vehículo</option>
                  </Input>
                  <button type="button" className='btn-icon rounded' style={{backgroundColor:c.verdeClaro}}>
                    <SvgAssets icon="icon-lupa" fill="#fff" />
                  </button>
                </FormGroup>
              </form>
            </div>
            <Link className='btn-block bg_transparent' to="/pedido-sugerido">PEDIDO SUGERIDO</Link>
            <Link className='btn-block bg_transparent' to="/pre-pedidos">PRE-PEDIDO<br />(Pasar Pre-Pedido)</Link>
            <Link className='btn-block bg_transparent' to="/buscador-vehiculo" style={{backgroundColor:c.azulClaro,color:'#fff'}}>REPETIR PEDIDO ANTERIOR</Link>
          </div>
          <div className="container_right">
            <h6 className="title morado">Resultado obtenido:</h6>
            <div className="resultados">
              <CardOferta />
              <CardOferta />
            </div>
            <section className="productos_destacados">
              <h6 className="title" style={{color:'#fff'}}>Productos destacados</h6>
              <Slider {...slider_destacados}>
                <ProductoDestacado />
                <ProductoDestacado />
                <ProductoDestacado />
                <ProductoDestacado />
                <ProductoDestacado />
                <ProductoDestacado />
                <ProductoDestacado />
              </Slider>
            </section>
            <section className="productos_vendidos">
              <h6 className="title" style={{color:c.rojoClaro}}>Productos más vendidos</h6>
              <Slider {...slider_vendidos} className="dots_blue">
                <ProductoVendido />
                <ProductoVendido />
                <ProductoVendido />
                <ProductoVendido />
              </Slider>
            </section>
          </div>
        </div>
      </div>
    )
  }
}